/**
 * Indica si el Admin ART/HyS puede ingresar a la cuenta seleccionada.
 *
 * No se habilita sin selección, mientras hay un ingreso en curso, ni cuando la
 * cuenta elegida es la misma con la que ya opera la sesión.
 *
 * @param {{ contrato?: number|string }|null} seleccion - Empresa elegida en `Company`
 * @param {number|string|null} contratoActivo - Contrato de la sesión
 * @param {boolean} ingresoEnCurso
 * @returns {boolean}
 */
export function puedeIngresar(seleccion, contratoActivo, ingresoEnCurso = false) {
  if (ingresoEnCurso) return false
  if (seleccion?.contrato == null || seleccion.contrato === '') return false
  if (contratoActivo == null || contratoActivo === '') return true

  return Number(seleccion.contrato) !== Number(contratoActivo)
}
